module.exports = __webpack_public_path__ + "media/images/LOGO-779e285f0c63e1baf50c80eee3602e0c.png";